module.exports = __webpack_public_path__ + "static/Tommy-ab61fdf8dc02e9682d3ae4fd4b8434f0.jpg";